import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Card from "../../Card";
import { getTp53Germline } from "../../../../state/selectors/Tp53.selectors";
import { getAMPSOMARule } from "../../../../state/selectors/AMPComponent.selectors";
import CardWrapper from "../../CardWrapper";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";

const IARCTP53GermlineCard = ({ card, color, tp53Data }) => {
  const backgroundColor =
    tp53Data && tp53Data?.total_samples < 3
      ? getPathogenicityColorByAllNames("VUS")
      : getPathogenicityColorByAllNames(color);
  let cancerTypes = "";
  if (tp53Data && tp53Data?.cancer_type) {
    tp53Data.cancer_type.forEach(
      (element) => (cancerTypes += `${element.key}, `)
    );
  }
  return (
    <CardWrapper
      {...card}
      isDisabled={tp53Data == null}
      color={backgroundColor}
    >
      {tp53Data && tp53Data?.total_samples ? (
        <div className="tw-mr-2">
          Samples: <b>{tp53Data.total_samples}</b>
        </div>
      ) : null}
      {cancerTypes ? (
        <div className="tw-truncate">
          Type: <b>{cancerTypes.slice(0, -2)}</b>
        </div>
      ) : null}
    </CardWrapper>
  );
};

IARCTP53GermlineCard.propTypes = {
  color: PropTypes.string,
  tp53Data: PropTypes.shape({
    total_samples: PropTypes.number,
    cancer_type: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  card: PropTypes.instanceOf(Card).isRequired,
};

IARCTP53GermlineCard.defaultProps = {
  color: "",
  tp53Data: {},
};

const mapStateToProps = (state) => ({
  color: getAMPSOMARule(state),
  tp53Data: getTp53Germline(state),
});

export default connect(mapStateToProps)(IARCTP53GermlineCard);
